import useStore from '@components/MainStage/store';
import { selectIsNodeAddedToAsset } from '@components/MainStage/store.selectors';
import { Modes } from '@constants/canvas/layers';
import { useProject } from '@context/Project/ProjectProvider';
import useAssets from '@hooks/useAssets';

const useIsNodeAddedToAsset = (nodeId: string) => {
  const {
    toolbox: { mode },
  } = useProject();

  const { selectedAssetId } = useAssets();

  return useStore(
    selectIsNodeAddedToAsset(
      nodeId,
      selectedAssetId,
      mode === Modes.RiskManagement,
    ),
  );
};

export default useIsNodeAddedToAsset;
